import { http } from '@/services';

export default {
  getSpecialtyList: async function() {
    try {
      return await http.get('especialidade/');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  getSpecialtyTheme: async function() {
    try {
      return await http.get('especialidade/tema/');
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  createSpecialty: async function(specialty) {
    try {
      return await http.post('especialidade/', specialty);
    } catch (e) {
      console.error(e);
      return e.response.data;
    }
  },
  editSpecialty: async function(currentSpecialty) {
    try {
      return await http.put('especialidade/', currentSpecialty);
    } catch (e) {
      return e.response.data;
    }
  },
  deleteSpecialty: async function(specialtyId) {
    try {
      return await http.delete(`especialidade/${specialtyId}`);
    } catch (e) {
      console.log(e);
      return e.response.data;
    }
  },
};
